// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1LOL5","disabled":"FileBtn_disabled__350h1","warn":"FileBtn_warn__FdSGX","fade":"FileBtn_fade__huwML"};